<template>
  <div class="memberIndex">
    <div class="right">
      <div class="currentMenu">在线竞价> 在线竞价</div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">在线竞价</div>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span class="searhTitle"> 项目名称</span>
            <el-input type="text" class="input" v-model="Query.ProjectName" size="mini"></el-input>

            <span class="searhTitle">竞价结束时间</span>
            <el-date-picker v-model="Query.EvaluationEndTime" type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels class="datepick"></el-date-picker>
            <el-button id="search" @click="fnGetData">搜索</el-button>
          </div>
          <el-table class="table_wrap1" :data="tableData.slice((currentPage - 1) * PageSize, currentPage * PageSize)" style="width: 100%" :height="height" :fit="true">
            <el-table-column prop="SchemeCode" label="采购编号"></el-table-column>
            <el-table-column prop="ProjectName" label="项目名称" width="250px"></el-table-column>
            <el-table-column prop="ProjectType" label="项目类型"></el-table-column>
            <el-table-column prop="BiddingDate" label="竞价时间" width="300px"></el-table-column>
            <el-table-column prop="TotalTenderAmount" label="我的报价"></el-table-column>
            <el-table-column prop="IsWin" label="竞价结果">
              <template slot-scope="scope">
                {{ scope.row.IsWin ? '竞价成功' : '竞价失败' }}
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="btn_wrap">
                  <el-button type="text" size="small" @click="fnDetail(scope.row.SchemeId, scope.row.ProjectName, scope.row.TotalTenderAmount)">查看报价明细</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      Query: {},
      tableData: [],
      Certify: false,
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      // 个数选择器（可修改）
      pageSizes: [10, 25, 50, 100],
      // 默认每页显示的条数（可修改）
      PageSize: 25,
      height: window.innerHeight - 268
    }
  },
  computed: {},
  mounted() {
    this.fnGetData()
  },
  methods: {
    fnGetData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }

      this.getRequest('Purchase/GetOnlineBiddingResultList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tableData = res.data.OnlineBiddingList
            this.totalCount = this.tableData.length
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    fnDetail(SchemeId, ProjectName, TotalTenderAmount) {
      let routerData = this.$router.resolve({
        name: 'OnlineBiddingDetail',
        query: {
          SchemeId: SchemeId,
          ProjectName: ProjectName,
          TotalTenderAmount: TotalTenderAmount
        }
      })
      window.open(routerData.href, '_blank')
    },
    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val
    }
  }
}
</script>
<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    width: 100%;
    background: #e4e4e4;
    // flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      // height: 93%;
      background: #f7f7f7;
      padding-bottom: 10px;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}

.block_wrap {
  display: flex;
}

.left_block {
  flex: 3;

  .flex_block {
    display: flex;

    .block {
      flex: 1;
      background: #fff;
      margin-right: 20px;
      text-align: center;
      align-items: center;
      padding: 13px 0;

      .text1 {
        font-size: 46px;
        color: #219cf8;
      }

      .text2 {
        margin-top: 4px;
        color: #054c81;
      }
    }

    .block:nth-last-of-type(1) {
      margin-right: 0;
    }
  }
}

.flex_bottom {
  padding: 10px 15px 3px;
  background: #fff;
  margin-top: 10px;

  .fb_title {
    margin-bottom: 0;
  }
}

.right_block {
  width: 220px;
  background: #fff;
  margin-left: 10px;
  padding: 18px 15px 0;

  .text {
    font-size: 16px;
    border-bottom: 1px solid #95c7f0;
    padding-bottom: 3px;
    font-weight: bold;
  }

  .row_imgs {
    display: flex;
    margin: 15px 0 25px;

    .img_block {
      flex: 1;
      text-align: center;
      cursor: pointer;

      img {
        margin-bottom: 20px;
      }
    }
  }

  .row_imgs:nth-last-of-type(1) {
    margin-top: 33px;
  }
}

.link {
  color: #0361b1;
  padding-right: 10px;
}
</style>